import { action, observable } from 'mobx';

import { BusyStore } from 'ui/base/button';
import { StringStore } from 'ui/base/input';
import { OSInputStore } from 'ui/standard/input/os_input/os_input_store';
import { DeviceTypeInputStore } from 'ui/standard/input/device_type_input/device_type_input_store';

import { ResultKind } from 'services/base/types';
import { Host, IPangolinDomain } from 'services/pangolin/types';
import { HostsService, HostsUpdateResult } from 'services/pangolin/hosts_service';

export class EditDeviceStore {
  host: Host;
  deviceName: StringStore;
  deviceType: DeviceTypeInputStore;
  deviceOS: OSInputStore;

  @observable.ref
  busy: BusyStore;

  constructor(host: Host) {
    this.host = host;
    this.deviceName = new StringStore(host.customName ?? '');
    this.deviceType = new DeviceTypeInputStore(host.customDeviceType);
    this.deviceOS = new OSInputStore(host.customOS);
    this.busy = new BusyStore();
  }

  @action.bound
  async handleSave(domain: IPangolinDomain): Promise<HostsUpdateResult> {
    if (domain.hosts.has(this.host.id)) {
      const customName = this.deviceName.value;
      const customDeviceType = this.deviceType.deviceType;
      const customOS = this.deviceOS.os;

      const result = await HostsService.update(domain, {
        id: this.host.id,
        customName: customName.length > 0 ? customName : undefined,
        customDeviceType: customDeviceType ?? undefined,
        customOS: customOS ?? undefined,
      });

      return result;
    }

    return { kind: ResultKind.SYSTEM_ERROR };
  }
}
